export default "__VITE_ASSET__C$2YbTDB__"